export const ROLES = {
    ADMIN: 1,
    CLIENT: 2,
    USER: 3,
    GUEST: 4,
    TANK: 5,
}